/**
 * Isophi portals
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * * `male` - male * `female` - female * `other` - other
 */
export type ExtendedGenderEnum = 'male' | 'female' | 'other';

export const ExtendedGenderEnum = {
    Male: 'male' as ExtendedGenderEnum,
    Female: 'female' as ExtendedGenderEnum,
    Other: 'other' as ExtendedGenderEnum
};